import React from 'react';
import './MobileTileGrid.css'; // Reuse the same styles

// Function to get a random color for categories
const getRandomColor = (label) => {
  // Generate a color based on the label to ensure consistency
  let hash = 0;
  for (let i = 0; i < label.length; i++) {
    hash = label.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Convert to a hex color
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    color += ('00' + value.toString(16)).substr(-2);
  }

  return color;
};

const MobileAdditionalBuylistTileGrid = ({ categories, onCategorySelect }) => {
  if (!categories || categories.length === 0) {
    return null; // Don't render anything if there are no categories
  }

  return (
    <div className="mobile-tile-grid" style={{ marginTop: '1rem' }}>
      <div style={{ padding: '0 1rem', marginBottom: '1rem' }}>
        <h2 style={{ color: 'white', margin: 0 }}>Additional Items</h2>
      </div>
      {categories.map((category, index) => {
        const backgroundColor = getRandomColor(category.button_label);
        return (
          <div
            key={index}
            className="mobile-tile small"
            style={{ backgroundColor }}
            onClick={() => onCategorySelect(category)}
          >
            <div className="mobile-tile-content">
              <div className="mobile-tile-name">{category.button_label}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MobileAdditionalBuylistTileGrid;
